import { render, staticRenderFns } from "./ModalCover.vue?vue&type=template&id=539048e4&scoped=true"
import script from "./ModalCover.vue?vue&type=script&lang=js"
export * from "./ModalCover.vue?vue&type=script&lang=js"
import style0 from "./ModalCover.vue?vue&type=style&index=0&id=539048e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539048e4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonsButton: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/Buttons/Button.vue').default})
